import {
  NewAnswerQuizInDto,
  NewAnswerQuizOutDto,
} from "../../../types/quiz.dto";

export const NEW_ANSWER_QUIZ = "NEW_ANSWER_QUIZ";
export const NEW_ANSWER_QUIZ_SUCCESS = "NEW_ANSWER_QUIZ_SUCCESS";
export const NEW_ANSWER_QUIZ_ERROR = "NEW_ANSWER_QUIZ_ERROR";
export const RESET_NEW_ANSWER_QUIZ = "RESET_NEW_ANSWER_QUIZ";

export interface NewAnswerQuiz {
  type: typeof NEW_ANSWER_QUIZ;
  payload: NewAnswerQuizOutDto;
}

export interface NewAnswerQuizSuccess {
  type: typeof NEW_ANSWER_QUIZ_SUCCESS;
  payload: NewAnswerQuizInDto;
}

export interface NewAnswerQuizError {
  type: typeof NEW_ANSWER_QUIZ_ERROR;
  payload: string | boolean;
}

export interface ResetNewAnswerQuiz {
  type: typeof RESET_NEW_ANSWER_QUIZ;
  payload: null;
}

export interface State {
  data: NewAnswerQuizInDto | null;
  states: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
};

export type Actions =
  | NewAnswerQuiz
  | NewAnswerQuizSuccess
  | NewAnswerQuizError
  | ResetNewAnswerQuiz;
